var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "main-internal-section width-full float-l" }, [
        _c(
          "div",
          { staticClass: "container" },
          [
            _vm.cantAccessPage === true
              ? [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "chat-btm-section-main add-user-main-section width-full float-l"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "web-add-form float-l width-full" },
                          [
                            _c(
                              "h2",
                              {
                                staticClass:
                                  "chat-page-title float-l colpie-80 color-333333 heading-text-18 line-height-22 font-bold ucase"
                              },
                              [_vm._v(" Update User ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "add-user-form width-full float-l mt_10 "
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "top-label-section update-user-top-section float-l width-full"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group float-l width-full p_15"
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"
                                          },
                                          [_vm._v(" Name ")]
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          staticClass:
                                            "form-control custom-select",
                                          attrs: {
                                            type: "text",
                                            placeholder: _vm.name,
                                            disabled: ""
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._m(0),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group float-l width-full p_15"
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"
                                          },
                                          [_vm._v(" Email Address ")]
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          staticClass:
                                            "form-control custom-select",
                                          attrs: {
                                            type: "text",
                                            placeholder: _vm.email,
                                            disabled: ""
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "btm-label-section float-l width-full bgcolor-f5f5f5"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group float-l width-full p_15"
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"
                                          },
                                          [_vm._v(" Dayforce ID")]
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          staticClass:
                                            "form-control custom-select",
                                          attrs: {
                                            type: "text",
                                            placeholder: _vm.emp_id,
                                            disabled: ""
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group float-l width-full p_15"
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"
                                          },
                                          [_vm._v(" Timezone ")]
                                        ),
                                        _vm._v(" "),
                                        _c("v-select", {
                                          attrs: {
                                            clearable: false,
                                            name: "timezoneId",
                                            placeholder: "Select Timezone.",
                                            label: "text",
                                            options: _vm.timezoneArr
                                          },
                                          model: {
                                            value: _vm.timezoneId,
                                            callback: function($$v) {
                                              _vm.timezoneId = $$v
                                            },
                                            expression: "timezoneId"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "color-333333 heading-text-16 line-height-18 font-benton-bold ucase pl_15 mt_20 float-l colpie-70"
                                      },
                                      [_vm._v(" Section / Role ")]
                                    ),
                                    _vm._v(" "),
                                    _vm._m(1),
                                    _vm._v(" "),
                                    _vm._m(2),
                                    _vm._v(" "),
                                    _vm._m(3),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "register-btn float-l col-12"
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-primary internal-large-btn float-l mr_20",
                                            attrs: { type: "update" },
                                            on: {
                                              click: function($event) {
                                                return _vm.createUser()
                                              }
                                            }
                                          },
                                          [
                                            _c("span", {
                                              staticClass: "gradient"
                                            }),
                                            _vm._v(
                                              " Update\n                                        "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-primary internal-large-btn internal-small-btn float-l",
                                            attrs: { type: "submit" },
                                            on: {
                                              click: function($event) {
                                                return _vm.backToUser()
                                              }
                                            }
                                          },
                                          [
                                            _c("span", {
                                              staticClass: "gradient"
                                            }),
                                            _vm._v(
                                              " Back\n                                        "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _vm._m(4)
                ]
              : [_vm.isRequestComplete ? [_vm._m(5)] : _vm._e()]
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("app-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticClass: "change-password float-r right width-full pr_15 mb_0" },
      [
        _c(
          "a",
          {
            staticClass:
              "color-f5911e font-benton-bold heading-text-14 line-height-16",
            attrs: {
              href: "#",
              "data-toggle": "modal",
              "data-target": "#password"
            }
          },
          [_vm._v(" Change Password ")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass:
          "btn btn-primary internal-large-btn internal-large-btn-blue float-l colpie-30 mt_15 float-r",
        attrs: { type: "submit" }
      },
      [
        _c("span", { staticClass: "gradient" }),
        _vm._v(" Add\n                                    ")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "form-group btm-web-role-section float-l width-full p_15"
      },
      [
        _c(
          "p",
          {
            staticClass:
              "select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"
          },
          [_vm._v(" Section ")]
        ),
        _vm._v(" "),
        _c(
          "select",
          { staticClass: "custom-select", attrs: { name: "cars" } },
          [
            _c("option", { attrs: { selected: "" } }, [_vm._v("Rental")]),
            _vm._v(" "),
            _c("option", { attrs: { value: "volvo" } }, [_vm._v("ABC")]),
            _vm._v(" "),
            _c("option", { attrs: { value: "fiat" } }, [_vm._v("XYZ")]),
            _vm._v(" "),
            _c("option", { attrs: { value: "audi" } }, [_vm._v("ABC")])
          ]
        ),
        _vm._v(" "),
        _c("span", [_c("i", { staticClass: "fa fa-angle-down" })])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "form-group btm-web-role-section float-l width-full p_15"
      },
      [
        _c(
          "p",
          {
            staticClass:
              "select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"
          },
          [_vm._v(" Role ")]
        ),
        _vm._v(" "),
        _c(
          "select",
          { staticClass: "custom-select", attrs: { name: "cars" } },
          [
            _c("option", { attrs: { selected: "" } }, [_vm._v("Admin")]),
            _vm._v(" "),
            _c("option", { attrs: { value: "volvo" } }, [_vm._v("User")])
          ]
        ),
        _vm._v(" "),
        _c("span", [_c("i", { staticClass: "fa fa-angle-down" })])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "modal fade forward-chat-modal email-chat-modal",
        attrs: {
          id: "password",
          tabindex: "-1",
          role: "dialog",
          "aria-labelledby": "password",
          "aria-hidden": "true"
        }
      },
      [
        _c("div", { staticClass: "modal-dialog" }, [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: {
                    type: "button",
                    "data-dismiss": "modal",
                    "aria-label": "Close"
                  }
                },
                [
                  _c("span", { attrs: { "aria-hidden": "true" } }, [
                    _vm._v("×")
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "h4",
                { staticClass: "modal-title", attrs: { id: "myModalLabel" } },
                [_vm._v("Change Password")]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "modal-body email-chat-main float-l width-full p_0"
              },
              [
                _c(
                  "div",
                  { staticClass: "form-group float-l width-full p_15" },
                  [
                    _c("input", {
                      staticClass: "form-control custom-select",
                      attrs: {
                        type: "password",
                        name: "email",
                        placeholder: "Enter your Password",
                        onfocus: "this.placeholder = ''",
                        onblur: "this.placeholder = 'Enter your Password'"
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group float-l width-full p_15" },
                  [
                    _c("input", {
                      staticClass: "form-control custom-select",
                      attrs: {
                        type: "password",
                        name: "email",
                        placeholder: "Confirm your Password",
                        onfocus: "this.placeholder = ''",
                        onblur: "this.placeholder = 'Confirm your Password'"
                      }
                    })
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "chat-forward-btm float-l width-full relative pl_15 pr_15"
              },
              [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-primary internal-large-btn float-l mr_20",
                    attrs: { type: "update" }
                  },
                  [
                    _c("span", { staticClass: "gradient" }),
                    _vm._v(" Send\n                                ")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-primary internal-large-btn internal-small-btn float-l",
                    attrs: { type: "submit" }
                  },
                  [
                    _c("span", { staticClass: "gradient" }),
                    _vm._v("  Cancel\n                                ")
                  ]
                )
              ]
            )
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("div", { staticClass: "error-template" }, [
        _c("h1", [_vm._v("\n                                Oops!")]),
        _vm._v(" "),
        _c("h2", [_vm._v("\n                                403 ")]),
        _vm._v(" "),
        _c("div", { staticClass: "error-details" }, [
          _vm._v(
            "\n                                Sorry!, You don't have permission to access this page.\n                            "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07257e28", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07257e28","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users/UserEdit.vue
// module id = null
// module chunks = 